// third-party
import { Trans } from 'react-i18next';

// assets
import { IconHistory, IconScan, IconReport,IconFlag } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconHistory,
    IconScan,
    IconReport,
    IconFlag,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface SystemMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}
const product: SystemMenuProps = {
    id: 'product',
    title: <Trans i18nKey="Product" id="Product" />,
    type: 'group',
    children: [
        {
            id: 'product-promotions',
            title: <Trans i18nKey="Product Promotions" id="Product Promotions" />,
            type: 'item',
            url: '/product-promotions',
            icon: icons.IconFlag,
            breadcrumbs: false,
        },
        {
            id: 'product-promotions-history',
            title: <Trans i18nKey="History" id="History" />,
            type: 'item',
            url: '/product-promotions-history',
            icon: icons.IconHistory,
            breadcrumbs: false
        },
        {
            id: 'product-promotions-sum-report',
            title: <Trans i18nKey="Report" id="Report" />,
            type: 'item',
            url: '/product-promotions-sum-report',
            icon: icons.IconReport,
            breadcrumbs: false
        },
        {
            id: 'product-promotions-statistics',
            title: <Trans i18nKey="Statistical" id="Statistical" />,
            type: 'item',
            url: '/product-promotions-statistics',
            icon: icons.IconReport,
            breadcrumbs: false
        },
        {
            id: 'price-checking',
            title: <Trans i18nKey="Price checking" id="Price checking" />,
            type: 'item',
            url: '/price-checking',
            icon: icons.IconScan,
            breadcrumbs: false
        }
    ]
};

export default product;
